export default __webpack_public_path__ + "static/media/icon_answer_credit_card.3ab6d347.svg";